const FacebookFullIcon = ({ className, ...props }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M7.29032 12.5868H9.26341V20.7097C9.26341 20.8701 9.39336 21 9.55374 21H12.8992C13.0596 21 13.1895 20.8701 13.1895 20.7097V12.6251H15.4577C15.6052 12.6251 15.7293 12.5144 15.7461 12.3679L16.0906 9.37746C16.1001 9.29518 16.074 9.21279 16.019 9.15106C15.9639 9.08928 15.885 9.05392 15.8023 9.05392H13.1896V7.17937C13.1896 6.61428 13.4939 6.32774 14.094 6.32774C14.1796 6.32774 15.8023 6.32774 15.8023 6.32774C15.9627 6.32774 16.0926 6.19773 16.0926 6.03741V3.29247C16.0926 3.1321 15.9627 3.00215 15.8023 3.00215H13.4481C13.4315 3.00134 13.3946 3 13.3402 3C12.9318 3 11.5119 3.08019 10.3903 4.11199C9.14763 5.2554 9.32037 6.62445 9.36166 6.86181V9.05386H7.29032C7.12995 9.05386 7 9.18381 7 9.34419V12.2964C7 12.4568 7.12995 12.5868 7.29032 12.5868Z"
                fill="currentColor"
            />
        </svg>
    )
}

export default FacebookFullIcon
